// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#2D2F45] text-white py-12 w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo Section */}
          <div>
            <a href="https://s360digital.com" target="_blank" rel="noopener noreferrer" className="text-2xl font-bold">
              s360
            </a>
          </div>

          {/* Services Section */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Services</h3>
            <ul className="space-y-0.5"> {/* Reduced spacing significantly */}
              <li><a href="https://s360digital.com/digital-marketing/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Digital Marketing</a></li>
              <li><a href="https://s360digital.com/creative/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Creative</a></li>
              <li><a href="https://s360digital.com/data-analytics/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Data & Analytics</a></li>
              <li><a href="https://s360digital.com/marketing-technology/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Marketing Technology</a></li>
              <li><a href="https://s360digital.com/media-strategy/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Media Strategy</a></li>
              <li><a href="https://s360digital.com/digital-growth/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Digital Growth</a></li>
            </ul>
          </div>

          {/* Information Section */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Information</h3>
            <ul className="space-y-0.5"> {/* Reduced spacing significantly */}
              <li><a href="https://s360digital.com/da/privatlivspolitik/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Privacy Policy</a></li>
              <li><a href="https://s360digital.com/newsletter/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Newsletter</a></li>
              <li><a href="https://s360digital.com/insights/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Insights</a></li>
              <li><a href="https://s360digital.com/cases/" target="_blank" rel="noopener noreferrer" className="text-gray-300 text-sm hover:text-white py-0.1 block">Cases</a></li>
            </ul>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-lg font-semibold mb-2">Contact us</h3>
            <div className="space-y-0.5"> {/* Reduced spacing for contact info */}
              <p className="text-gray-300 text-sm">contact@s360digital.com</p>
              <p className="text-gray-300 text-sm">+45 70 70 22 43</p>
            </div>
            
            <h3 className="text-lg font-semibold mt-6 mb-2">Address</h3>
            <div className="space-y-0.5"> {/* Reduced spacing for address */}
              <p className="text-gray-300 text-sm">Mariane Thomsens Gade 2F, 4</p>
              <p className="text-gray-300 text-sm">8000 Aarhus</p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 border-t border-gray-700 pt-6">
          <p className="text-gray-400">© 2025 s360 A/S. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;